import './styles.css';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideNotification } from './../../actions/notification';
import ApaMetadata from './../../requests/apa/Metadata';
import Device from '../../devices/device';
import Asset from '../../requests/apa/Asset';
import { Grid, Row, Column, cls } from '../../packages/components';
import Utils from 'src/utils/Utils'
import { MODAL_INACTIVITY } from 'src/actions/modal';
import logger from 'src/utils/logger/logger';

class Notification extends Component {
  constructor(props) {
    super(props);
    this.keys = Device.getDevice().getKeys();
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.idFocusOnShortcu = null;
    this.refTimeout = null;
  }

  setTimeShowing = () => {
    switch (this.props.type){
      case 'notification':
        this.timeShowing = ApaMetadata.get('notification_viewing_time', 30000);//30000
        break;
      case 'message':
        this.timeShowing = ApaMetadata.get('notification_viewing_time', 30000);//30000
        break;
      default:
        this.timeShowing = ApaMetadata.get('notification_viewing_time', 30000);//notification_viewing_time 30000
    }
  }

  setFocusOnShortcut = () => {
    this.idFocusOnShortcut = setTimeout(()=>{
      window.SpatialNavigation.focus('#notification-shortcut-button');
      this.idFocusOnShortcut = null;
    }, 300); // este timeout es porque en STB el evento click se propaga al shortcut
  }

  componentDidUpdate(prevProps) {
    this.setTimeShowing();
    Utils.modalType() !== MODAL_INACTIVITY && this.setFocusOnShortcut();
    if (!prevProps.show) this.closeNotification();
  }

  closeNotification = () => {
    const {
      timeShowing,
      hideNotification = () => { },
      closeNotificationCallback = () => { }
    } = this.props;


    if (timeShowing) {
      this.timeShowing = timeShowing;
    }

    if(this.refTimeout) {
      clearTimeout(this.refTimeout);
      this.refTimeout = null;
    }

    this.refTimeout = setTimeout(() => {
      hideNotification({
        show: false,
        title: '',
        msg: ''
      });
      closeNotificationCallback();
    }, this.timeShowing);
  }

  makeIcon = () => {
    let icon = null;
    const { faClass, apaAsset, apaAssetDefault } = this.props
    if (faClass) {
      icon = <i className={`fa ${this.props.faClass}`} />
    } else if (apaAsset) {
      icon = <img src={Asset.get(apaAsset, apaAssetDefault)} alt="icon" />;
    }
    return icon;
  }

  componentDidMount() {
    document.removeEventListener('keydown', this.handleKeyPress, true);
    document.addEventListener('keydown', this.handleKeyPress, true);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyPress, true);
  }

  handleKeyPress(e) {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
    const { handleGreenPress, show, handleRedPress, handleBluePress, handleYellowPress, hideNotification } = this.props;
    logger.debug('Notification _handleKeyPress currentKey', currentKey);
    if (!show)
      return;
    switch (currentKey) {
      case "DOWN":
        logger.error("DOWN")
        break
      case "GREEN":
        if (typeof handleGreenPress === 'function') {
          e.stopPropagation();
          e.preventDefault();
          handleGreenPress(e);
          hideNotification({
            show: false,
            title: '',
            msg: ''
          });
        }
        break;
      case "RED":
        if (typeof handleRedPress === 'function') {
          e.stopPropagation();
          e.preventDefault();
          handleRedPress();
          hideNotification({
            show: false,
            title: '',
            msg: ''
          });
        }
        break;
      case "BLUE":
        if (typeof handleBluePress === 'function') {
          e.stopPropagation();
          e.preventDefault();
          handleBluePress();
          hideNotification({
            show: false,
            title: '',
            msg: ''
          });
        }
        break;
      case "YELLOW":
        if (typeof handleYellowPress === 'function') {
          e.stopPropagation();
          e.preventDefault();
          handleYellowPress();
          hideNotification({
            show: false,
            title: '',
            msg: ''
          });
        }
        break;
      default:
    }
  }

  render() {
    const { title, msg, separator = "", renderMessage, show, typeNotification } = this.props;
    const messageToDisplay = typeof renderMessage === 'function' ? renderMessage() : msg
    const icon = this.makeIcon();
    // Se mantiene oculto cuando NotificationConductor está mostrando otro tipo (ej. TOAST_NOTIFICATION) sobre el mismo state
    const isVisible = show && typeNotification !== 'TOAST_NOTIFICATION';
    return (
      <div className={`app-notification-wrapper ${!isVisible && 'hide'}`}>

        <Grid className="app-notification-grid">
          <Row className="app-notification-row">
            <Column className="app-notification-column" lg={12}>
              {/* Bloques para centrar el div en pantalla */}
              <div className="app-notification-tocenter-top">
                <div className="app-notification-tocenter-outer">
                  <div className="app-notification-tocenter-inner">
                    {/* TERMINA:  Bloques para centrar el div en pantalla */}
                    {/* Bloques para el ícono + el título de la notificación, centrado verticalmente */}
                    <div className="app-notification-section-content">
                      {icon &&
                      <div className="app-notification-section-title-inner-icon">
                        {icon}
                      </div>
                      }
                      <div className={"app-notification-section-title-inner"}>
                        <div className={cls('app-notification-section-texttitle', {
                            "app-notification-section-texttitle-rad": !messageToDisplay,
                            "app-notification-section-texttitle-no-icon": !icon,
                            "app-notification-section-texttitle-only-msg": !icon && !messageToDisplay,
                          })}> {title} </div>

                        {messageToDisplay &&
                          <div className="app-notification-section-separator"> {
                            separator !== "" ? separator : "|"
                          }</div>
                        }

                        {messageToDisplay
                        &&
                        <div className={cls('app-notification-section-message', {
                          "app-notification-section-message-bg": typeof renderMessage !== 'function'
                        })}>
                          {messageToDisplay}
                        </div>
                        }
                      </div>
                    </div>
                    {/* TERMINA Bloques para el ícono + el título de la notificación, centrado verticalmente */}
                  </div>
                </div>
              </div>

            </Column>
          </Row>
        </Grid>
      </div>
    )
  }
}

Notification.propTypes = {
  title: PropTypes.string.isRequired,
  msg: PropTypes.string,
  renderMessage: PropTypes.func,
  show: PropTypes.bool.isRequired,
  faClass: PropTypes.string,
  apaAsset: PropTypes.string,
  apaAssetDefault: PropTypes.string,
  type: PropTypes.oneOf("notification", "message"),
  handleGreenPress: PropTypes.func,
  handleRedPress: PropTypes.func,
  handleBluePress: PropTypes.func,
  handleYellowPress: PropTypes.func,
  closeNotificationCallback: PropTypes.func,
};

Notification.defaultProps = {
  title: '',
  msg: '',
  renderMessage: null,
  show: false,
  faClass: null,
  apaAsset: null,
  apaAssetDefault: null,
  type: "notification",
  handleGreenPress: null,
  handleRedPress: null,
  handleBluePress: null,
  handleYellowPress: null,
  closeNotificationCallback: () => { }
};

const mapStateToProps = state => ({ ...state.notification.notificationProps });
const mapDispatchToProps = (dispatch) => bindActionCreators({
  hideNotification
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Notification);



// WEBPACK FOOTER //
// ./src/components/Notification/index.jsx